module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-5-4daccda3b11946e7c0b0aff5c4408b38.webp";